import { render, staticRenderFns } from "./ExcelFileUpload.vue?vue&type=template&id=2b936200&scoped=true"
import script from "./ExcelFileUpload.vue?vue&type=script&lang=js"
export * from "./ExcelFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b936200",
  null
  
)

export default component.exports